
import Vue from 'vue'

import {
     Button, MessageBox, Card, Message, Form, FormItem, Input, Select, Row, Col, Tabs, TabPane, Icon, Radio, DatePicker, Link,
     Checkbox, Upload, CheckboxGroup, Table, TableColumn, Pagination, Divider, Carousel, CarouselItem, Dialog, Option, Empty, Descriptions, DescriptionsItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Option)
Vue.use(CheckboxGroup)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
// Vue.use(Message)
Vue.use(Empty)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(TabPane)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Link)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Divider)
Vue.use(Dialog)
Vue.component(Message.name, Message)
Vue.component(MessageBox.name, MessageBox)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm